import { fromJS } from "immutable";
import AppConstants from "../constants/AppConstants";

const { CANVAS_SET_BLOCK_CONTENT_SEPARATOR } = AppConstants;

/**
 *
 * @param {List|Array} canvasSetList
 */
export const splitCanvasSet = (canvasSetList) => {
  const separatorIndex = canvasSetList.indexOf(CANVAS_SET_BLOCK_CONTENT_SEPARATOR);
  const top = canvasSetList.slice(0, separatorIndex);
  const bottom = canvasSetList.slice(separatorIndex + 1).filter((item) => item);
  const result = [top, bottom];
  return {
    asArray: () => (Array.isArray(top) ? result : result.map((item) => item.toJS())),
    asImmutable: () => fromJS(result),
  };
};

export default {
  splitCanvasSet,
};
